import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import {
  MdOutlineArrowLeft,
  MdOutlineArrowRight,
  MdOutlineDashboardCustomize,
  MdOutlineInfo,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { selectReduxInstance } from "../../../redux/ReduxInstance";

const BoardViewMenu = (props) => {
  const { process, handleShowModal } = props;
  const ReduxInstance = useSelector(selectReduxInstance);
  const { ReduxUserEmail, ReduxUserIdColidee, ReduxInstancesAutorisees } = useSelector(
    (state) => state.ReduxUser
  );
  const [indexProcess, setIndexProcess] = useState("");
  const [processes, setProcesses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (process.famille === "MacroProcess") {
      recupProcesses();
    }
  }, []);

  /* test affichage menu adminEasygouv */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const recupProcesses = async () => {
    const res = await apiGetProcesses(
      ReduxInstance._id,
      "filter[famille]=MacroProcess&sort[ordre]=-1"
    );
    if (res) {
      setProcesses(res.data);
      setIndexProcess(res.data.findIndex((element) => element._id === process._id));
    }
  };

  return (
    <Container>
      <div style={{ padding: 8, textAlign: "center" }}>
        {process.famille === "MacroProcess" && (
          <Button
            disabled={processes.findIndex((element) => element._id === process._id) === 0}
            style={{ margin: 4, "font-size": "1.5rem" }}
            onClick={() =>
              navigate(
                "/processes/" +
                  processes[processes.findIndex((element) => element._id === process._id) - 1]._id
              )
            }
          >
            <MdOutlineArrowLeft />
          </Button>
        )}
        <Button
          onClick={() => handleShowModal(process)}
          style={{ margin: 4, "font-size": "1.5rem" }}
        >
          <MdOutlineInfo />
        </Button>
        {isAdminEasygouv() && (
          <Button
            style={{ margin: 4, "font-size": "1.5rem", "background-color": "red" }}
            role="button"
            onClick={() => navigate("/admin/easygouv/processes/" + process._id + "/view")}
          >
            <MdOutlineDashboardCustomize />
          </Button>
        )}
        {process.famille === "MacroProcess" && (
          <Button
            disabled={
              processes.length <= processes.findIndex((element) => element._id === process._id) + 1
            }
            style={{ margin: 4, "font-size": "1.5rem" }}
            onClick={() =>
              navigate(
                "/processes/" +
                  processes[processes.findIndex((element) => element._id === process._id) + 1]._id
              )
            }
          >
            <MdOutlineArrowRight />
          </Button>
        )}
      </div>
    </Container>
  );
};

export default BoardViewMenu;
